module.exports = __webpack_public_path__ + "static/media/llp-home-banner-desktop.da12bd2c.png";